import { Typography } from "@mui/material";
import {
  useGridApiContext,
  useGridSelector,
  gridSortedRowEntriesSelector,
  GridToolbarContainer,
  GridToolbarExport,
  type GridCsvExportOptions,
  gridSortedRowIdsSelector,
} from "@mui/x-data-grid";
import moment from "moment";

const HIDDEN_EXPORT_FIELDS = ["_actions"];

interface PpToolbarProps {
  status: string;
}

export const PpToolbar = ({ status }: PpToolbarProps) => {
  const apiRef = useGridApiContext();
  const filteredRows = useGridSelector(apiRef, gridSortedRowEntriesSelector);

  const columns = apiRef.current.getVisibleColumns();
  const fieldsForExport = columns
    .map((col) => col.field)
    .filter((field) => !HIDDEN_EXPORT_FIELDS.includes(field));

  const csvOptions: GridCsvExportOptions = {
    fields: fieldsForExport,
    fileName: moment().format(`[PP_Export_${status}]_MMMM_DD_YYYY`),
    getRowsToExport: ({ apiRef }) => gridSortedRowIdsSelector(apiRef),
  };

  return (
    <GridToolbarContainer
      sx={{
        padding: "1em",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="h6">
        Showing: {filteredRows.length || 0} Matches
      </Typography>

      <GridToolbarExport csvOptions={csvOptions} />
    </GridToolbarContainer>
  );
};
